<template>
    <div>
        <div class="create_notif">
            <NewNotification
                @addnotification="addNotification"
                :channels="channels"
            />
        </div>
        <div>
          <ListScheduledNotifications
                :notifications="scheduledNotifications"
                :channels="channels"
          />
        </div>
        <div>
            <ListNotifications
                :notifications="notifications"
                :channels="channels"
                v-model="pagination"
                :pageNum="pageNum"
            />
        </div>
    </div>
</template>

<script>
    import NewNotification from './NewNotification'
    import ListNotifications from './ListNotifications'
    import ListScheduledNotifications from "@/components/ListScheduledNotifications";

    export default {
        components: {
            ListScheduledNotifications,
            NewNotification,
            ListNotifications
        },
        data() {
            return {
                intervalHandle: null,
                notifications: [],
                scheduledNotifications: [],
                channels: {
                    highlights: 'Het Beste van NRC',
                    breaking_news: 'Nieuws'
                },
                pagination: {
                    offset: 0,
                    limit: 10,
                    channel: '',
                },
                pageNum: 1,
            }
        },
        created() {
            this.getNotifications()
            this.getScheduledNotifications()
            this.intervalHandle = setInterval(() => {
              this.getNotifications()
              this.getScheduledNotifications()
            }, 10000)
        },
        beforeDestroy() {
            if (this.intervalHandle !== null) {
                clearInterval(this.intervalHandle)
            }
        },
        methods: {
            addNotification: function() {
                this.getNotifications()
                this.getScheduledNotifications()
            },
            getNotifications: function() {
                this.$api.getNotifications(this.pagination.limit, this.pagination.offset, this.pagination.channel)
                .then(data =>
                    this.notifications = data,
                    this.pageNum = parseInt(this.pagination.offset / this.pagination.limit) + 1
                )
            },
            getScheduledNotifications: function () {
                this.$api.getScheduledNotifications()
                    .then(data =>
                       this.scheduledNotifications = data
                    )
            }
        },
        watch: {
            pagination: function() {
                this.getNotifications()
            }
        }
    }
</script>

<style>
    .slide-fade-enter-active {
        transition: all 1.2s ease;
    }
    .slide-fade-leave-active {
        display:none;
        /*transition: all .0s none;*/
        /*transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);*/
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
    .select {
        font-size: 14px;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        color: #444;
        padding: 8px 22px 8px 8px;
        box-sizing: border-box;
        margin: 0;
        border: 1px solid #e0e0e0;
        border-radius: 3px;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        background-color: #fff;
        background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
        background-repeat: no-repeat, repeat;
        background-position: right .7em top 50%, 0 0;
        background-size: .65em auto, 100%;
    }
    .select:-ms-expand {
        display: none;
    }
    .select:hover {
        border-color: #888;
    }
    .select:focus {
        border-color: #aaa;
        box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);
        box-shadow: 0 0 0 3px -moz-mac-focusring;
        color: #222;
        outline: none;
    }
    .select-css option {
        font-weight:normal;
    }
</style>
